import Card from "@pathwright/ui/src/components/card/Card"
import CardBack from "@pathwright/ui/src/components/card/CardBack"
import Screensize, {
  useScreensizeContext
} from "@pathwright/ui/src/components/ui/Screensize"
import PropTypes from "prop-types"
import styled from "styled-components"
import CategoriesQuery from "../category/graphql/CategoriesQuery"
import ThemeProvider from "../pathwright/ThemeProvider"
import SchoolContext from "../school/SchoolContext"
import BrowseContainer from "../store/browse/BrowseContainer"
import { LICENSING_MODE_SCHOOL_LICENSING } from "../store/resource/offering/license/constants"

const StyledCard = styled(Card)`
  padding-top: 0 !important;
  &:last-child {
    min-height: 100vh;
  }

  .Banner {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    overflow: hidden;
  }
`

function BelltowerBrowseCard({ card, schoolId, browseTo }) {
  const screensize = useScreensizeContext()
  return (
    <SchoolContext.Provider schoolId={schoolId}>
      <StyledCard
        card={card}
        emphasis="secondary"
        navless
        rounded={screensize !== "sm"}
        style={screensize !== "sm" ? { overflow: "hidden" } : {}}
      >
        <Screensize.Consumer>
          {(screensize) => (
            <CategoriesQuery schoolId={schoolId} first={50}>
              {({ categories }) =>
                categories && (
                  <Screensize.Provider
                    screensize={screensize === "sm" ? "sm" : "md"}
                  >
                    <ThemeProvider schoolId={schoolId}>
                      <BrowseContainer
                        children={<CardBack card={card} inverted />}
                        browseTo={browseTo}
                        schoolId={schoolId}
                        licensingMode={LICENSING_MODE_SCHOOL_LICENSING}
                        structure={categories.map((c) => ({
                          heading: c.name,
                          queryOptions: { categoryIdFilter: { eq: c.id } }
                        }))}
                        inCard
                      />
                    </ThemeProvider>
                  </Screensize.Provider>
                )
              }
            </CategoriesQuery>
          )}
        </Screensize.Consumer>
      </StyledCard>
    </SchoolContext.Provider>
  )
}

BelltowerBrowseCard.displayName = "BelltowerBrowseCard"

BelltowerBrowseCard.propTypes = {
  card: PropTypes.object.isRequired,
  schoolId: PropTypes.number.isRequired,
  browseTo: PropTypes.func.isRequired
}

export default BelltowerBrowseCard
